/**
 * Role-based Dashboard Configuration
 * Defines different dashboard views and layouts for different user roles
 */

export const ROLE_DASHBOARDS = {
  admin: {
    homeView: 'dashboard',
    allowedSections: [
      'dashboard',
      'orders',
      'order-history',
      'menu-editor',
      'inventory',
      'list-all-items',
      'delivery-partners',
      'delivery-tracking',
      'kitchen-display',
      'stock-alerts',
      'manage-locations',
      'role-permissions',
      'billing-dashboard',
      'create-invoice',
      'gst-settings',
      'expense-management',
      'profit-loss',
      'cash-flow',
      'payouts',
      'transactions',
      'invoices',
      'create-offers',
      'track-offers',
      'phone-order',
      'thermal-printer',
      'customers',
      'users',
      'analytics',
      'reviews',
      'menu',
      'calendar',
      'chat',
      'data-management',
      'settings'
    ],
    features: {
      canManageUsers: true,
      canManagePermissions: true,
      canViewFinance: true,
      canManageSettings: true,
      canDeleteData: true
    }
  },
  manager: {
    homeView: 'orders',
    allowedSections: [
      'orders',
      'order-history',
      'menu-editor',
      'inventory',
      'list-all-items',
      'delivery-partners',
      'delivery-tracking',
      'kitchen-display',
      'stock-alerts',
      'create-offers',
      'track-offers',
      'phone-order',
      'thermal-printer',
      'customers',
      'analytics',
      'reviews',
      'calendar',
      'chat'
    ],
    features: {
      canManageUsers: false,
      canManagePermissions: false,
      canViewFinance: false,
      canManageSettings: false,
      canDeleteData: false
    }
  },
  kitchen: {
    homeView: 'kitchen-display',
    allowedSections: [
      'kitchen-display',
      'orders',
      'inventory',
      'stock-alerts',
      'menu-editor'
    ],
    features: {
      canManageUsers: false,
      canManagePermissions: false,
      canViewFinance: false,
      canManageSettings: false,
      canDeleteData: false
    }
  },
  delivery: {
    homeView: 'delivery-tracking',
    allowedSections: [
      'delivery-tracking',
      'orders'
    ],
    features: {
      canManageUsers: false,
      canManagePermissions: false,
      canViewFinance: false,
      canManageSettings: false,
      canDeleteData: false
    }
  }
};

/**
 * Get dashboard configuration for a specific role
 */
export const getDashboardForRole = (role) => {
  const normalizedRole = role?.toLowerCase() || 'delivery';
  return ROLE_DASHBOARDS[normalizedRole] || ROLE_DASHBOARDS.delivery;
};

/**
 * Check if a role can access a specific section
 */
export const canRoleAccessSection = (role, section) => {
  const dashboard = getDashboardForRole(role);
  return dashboard.allowedSections.includes(section);
};

/**
 * Get home view for a role
 */
export const getHomeViewForRole = (role) => {
  const dashboard = getDashboardForRole(role);
  return dashboard.homeView;
};

/**
 * Check if a role has a specific feature
 */
export const roleHasFeature = (role, feature) => {
  const dashboard = getDashboardForRole(role);
  return dashboard.features[feature] || false;
};
